/** Why an admin's client lookup cannot be ordered for. */
export enum PFClientSelectionError {
  NOT_FOUND = 'NOT_FOUND',
  NOT_CLIENT = 'NOT_CLIENT',
  NO_DATA = 'NO_DATA'
}
